module.exports = __webpack_public_path__ + "img/25_40.abd7e3c5.png";